(function(){
  var toastTimer;

  function initFallbackGallery(root){
    root.querySelectorAll('[data-rc-fallback-gallery]:not([data-rc-ready])').forEach(function(gallery){
      gallery.dataset.rcReady='true';
      var main=gallery.querySelector('[data-rc-fallback-main]');
      gallery.addEventListener('click',function(event){
        var thumb=event.target.closest('[data-rc-fallback-thumb]');
        if(!thumb||!main)return;
        main.src=thumb.dataset.src;
        gallery.querySelectorAll('[data-rc-fallback-thumb]').forEach(function(item){
          var active=item===thumb;
          item.classList.toggle('is-active',active);
          item.setAttribute('aria-pressed',String(active));
        });
      });
    });
  }

  function showToast(){
    var toast=document.querySelector('[data-rc-product-toast]');
    if(!toast)return;
    window.clearTimeout(toastTimer);
    toast.classList.add('is-visible');
    toastTimer=window.setTimeout(function(){toast.classList.remove('is-visible')},3200);
  }

  function initToastSubscription(){
    if(window.rcProductToastSubscribed||typeof window.subscribe!=='function'||!window.PUB_SUB_EVENTS)return;
    window.rcProductToastSubscribed=true;
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate,function(event){
      var payload=event&&event.data?event.data:event;
      if(payload&&payload.source==='product-form')showToast();
    });
  }

  function copyText(text){
    if(navigator.clipboard&&navigator.clipboard.writeText){return navigator.clipboard.writeText(text)}
    // Fallback for older/insecure contexts where the async clipboard is unavailable.
    return new Promise(function(resolve,reject){
      try{
        var ta=document.createElement('textarea');
        ta.value=text;ta.setAttribute('readonly','');
        ta.style.position='fixed';ta.style.top='-9999px';ta.style.opacity='0';
        document.body.appendChild(ta);ta.focus();ta.select();
        var ok=document.execCommand('copy');
        document.body.removeChild(ta);
        ok?resolve():reject(new Error('copy failed'));
      }catch(e){reject(e)}
    });
  }

  function flashCopied(btn){
    btn.classList.add('is-copied');
    window.clearTimeout(btn._rcCopyTimer);
    btn._rcCopyTimer=window.setTimeout(function(){btn.classList.remove('is-copied')},1800);
  }

  function initPromoCopy(root){
    root.querySelectorAll('[data-rc-copy]:not([data-rc-copy-ready])').forEach(function(btn){
      btn.dataset.rcCopyReady='true';
      btn.addEventListener('click',function(){
        var code=btn.getAttribute('data-rc-copy');
        if(!code)return;
        copyText(code).then(function(){flashCopied(btn)}).catch(function(){
          // Even if the copy API is blocked, confirm to the shopper — the code is
          // right there to select by hand — rather than fail silently.
          flashCopied(btn);
        });
      });
    });
  }

  function init(root){
    initFallbackGallery(root);
    initToastSubscription();
    initPromoCopy(root);
  }

  function ready(){init(document)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready,{once:true});else ready();
  document.addEventListener('shopify:section:load',function(event){init(event.target)});
})();
